import React, { useState } from 'react';
type FormData = {
  businessStatus: string;
  volume: string;
  ads: string;
  budget: string;
  crm: string;
  name: string;
  email: string;
  phone: string;
  businessName: string;
};
export function ApplicationForm() {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState<FormData>({
    businessStatus: '',
    volume: '',
    ads: '',
    budget: '',
    crm: '',
    name: '',
    email: '',
    phone: '',
    businessName: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSelect = (field: keyof FormData, value: string) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };
  const handleNext = () => {
    if (step < 6) {
      setStep(prev => prev + 1);
      document.getElementById('apply')?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  const handleBack = () => {
    if (step > 1) {
      setStep(prev => prev - 1);
      document.getElementById('apply')?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  const handleSubmit = async () => {
    if (!formData.name || !formData.email || !formData.phone) {
      alert('Por favor completa tu nombre, correo y teléfono.');
      return;
    }
    // TODO: Connect to GoHighLevel (GHL) Webhook
    // Replace the URL below with your actual GHL Webhook URL
    /*
    try {
      await fetch('YOUR_GHL_WEBHOOK_URL_HERE', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
    } catch (error) {
      console.error('Error sending data to GHL:', error);
    }
    */
    setIsSubmitted(true);
  };
  const isDisqualified = formData.businessStatus === 'no' || formData.businessStatus === 'start';
  const showBudgetWarning = formData.budget === 'under';
  const canProceed = () => {
    switch (step) {
      case 1:
        return formData.businessStatus !== '' && !isDisqualified;
      case 2:
        return formData.volume !== '';
      case 3:
        return formData.ads !== '';
      case 4:
        return formData.budget !== '';
      case 5:
        return formData.crm !== '';
      default:
        return false;
    }
  };
  const Option = ({
    field,
    value,
    label
  }: {
    field: keyof FormData;
    value: string;
    label: string;
  }) => {
    const isSelected = formData[field] === value;
    return <div className={`flex items-center gap-4 p-4 border cursor-pointer transition-all duration-150 text-[15px] select-none ${isSelected ? 'border-gold bg-gold-pale text-cream' : 'border-[#1e1e1e] bg-[#0e0e0e] text-[#888] hover:border-gold-line hover:text-cream'}`} onClick={() => handleSelect(field, value)} data-id="element-9">
        <div className={`w-4 h-4 border rounded-full shrink-0 flex items-center justify-center transition-all duration-150 ${isSelected ? 'border-gold bg-gold' : 'border-[#333]'}`} data-id="element-10">
          {isSelected && <div className="w-[5px] h-[5px] bg-ink rounded-full" data-id="element-11" />}
        </div>
        {label}
      </div>;
  };
  return <section className="py-[80px] px-6 md:py-[120px] md:px-[72px] bg-surface border-t border-subdued" id="apply" data-id="element-12">
      <div className="max-w-[760px] mx-auto" data-id="element-13">
        <div className="text-center mb-16" data-id="element-14">
          <div className="inline-flex items-center justify-center gap-2.5 text-[10px] tracking-[3px] uppercase text-gold mb-5 font-medium" data-id="element-15">
            <span className="w-6 h-px bg-gold" data-id="element-16"></span>
            Aplicar Ahora
          </div>
          <h2 className="font-serif text-[clamp(36px,4vw,58px)] font-light tracking-tight mb-4 text-cream" data-id="element-17">
            Descubre si podemos
            <br data-id="element-18" />
            hacer crecer tu negocio.
          </h2>
          <p className="text-base text-muted" data-id="element-19">
            Responde algunas preguntas para que podamos entender tu situación y
            decirte exactamente cómo escalaríamos tu pipeline.
          </p>
        </div>

        <div className="border border-subdued bg-ink p-9 md:py-[60px] md:px-16 relative overflow-hidden" data-id="element-20">
          <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold to-transparent" data-id="element-21" />

          {!isSubmitted ? <>
              {/* Progress Bar */}
              <div className="flex items-center gap-1.5 mb-12" data-id="element-22">
                {[1, 2, 3, 4, 5, 6].map(i => <div key={i} className={`flex-1 h-px transition-colors duration-300 ${i <= step ? 'bg-gold' : 'bg-subdued'}`} data-id="element-23" />)}
              </div>

              {/* Step 1 */}
              {step === 1 && <div className="animate-fade-up" data-id="element-24">
                  <div className="text-[11px] tracking-[2px] uppercase text-gold mb-3" data-id="element-25">
                    1 de 6
                  </div>
                  <h3 className="font-serif text-[30px] font-light tracking-tight mb-2 leading-[1.2] text-cream" data-id="element-26">
                    ¿Tienes actualmente un negocio activo de reparación de
                    crédito?
                  </h3>
                  <p className="text-sm text-muted mb-8 leading-relaxed" data-id="element-27">
                    Necesitamos asegurarnos de que podemos entregar resultados
                    reales para ti.
                  </p>

                  <div className="flex flex-col gap-2" data-id="element-28">
                    <Option field="businessStatus" value="yes" label="Sí — estoy inscribiendo clientes activamente" data-id="element-29" />
                    <Option field="businessStatus" value="start" label="Estoy empezando (menos de 3 meses)" data-id="element-30" />
                    <Option field="businessStatus" value="no" label="Aún no — estoy en la etapa de planificación" data-id="element-31" />
                  </div>

                  {isDisqualified && <div className="mt-6 p-7 border border-[#1e1e1e] bg-[#0a0a0a] text-center animate-fade-up" data-id="element-32">
                      <h4 className="font-serif text-2xl font-light mb-2.5 text-cream" data-id="element-33">
                        Todavía no es el momento indicado.
                      </h4>
                      <p className="text-sm text-muted leading-relaxed" data-id="element-34">
                        Nuestro sistema da los mejores resultados para negocios
                        que ya tienen clientes y un servicio comprobado. Regresa
                        cuando estés inscribiendo clientes — aquí estaremos.
                      </p>
                    </div>}

                  <div className="flex justify-end mt-9" data-id="element-35">
                    <button onClick={handleNext} disabled={!canProceed()} className="bg-transparent border border-gold text-gold font-sans text-xs font-medium tracking-[1.5px] uppercase py-[13px] px-8 cursor-pointer transition-all duration-200 hover:bg-gold hover:text-ink disabled:border-[#2a2a2a] disabled:text-[#2a2a2a] disabled:cursor-not-allowed disabled:hover:bg-transparent" data-id="element-36">
                      Siguiente →
                    </button>
                  </div>
                </div>}

              {/* Step 2 */}
              {step === 2 && <div className="animate-fade-up" data-id="element-37">
                  <div className="text-[11px] tracking-[2px] uppercase text-gold mb-3" data-id="element-38">
                    2 de 6
                  </div>
                  <h3 className="font-serif text-[30px] font-light tracking-tight mb-2 leading-[1.2] text-cream" data-id="element-39">
                    ¿Cuántos clientes nuevos estás inscribiendo por mes?
                  </h3>
                  <p className="text-sm text-muted mb-8 leading-relaxed" data-id="element-40">
                    Esto nos ayuda a establecer expectativas realistas para tu
                    negocio.
                  </p>

                  <div className="flex flex-col gap-2" data-id="element-41">
                    <Option field="volume" value="0-5" label="0–5 clientes/mes" data-id="element-42" />
                    <Option field="volume" value="6-15" label="6–15 clientes/mes" data-id="element-43" />
                    <Option field="volume" value="16-30" label="16–30 clientes/mes" data-id="element-44" />
                    <Option field="volume" value="30+" label="30+ clientes/mes" data-id="element-45" />
                  </div>

                  <div className="flex justify-between items-center mt-9" data-id="element-46">
                    <button onClick={handleBack} className="bg-transparent border border-[#2a2a2a] text-muted font-sans text-xs font-medium tracking-wide uppercase py-3 px-6 cursor-pointer transition-all duration-200 hover:border-muted hover:text-cream" data-id="element-47">
                      ← Atrás
                    </button>
                    <button onClick={handleNext} disabled={!canProceed()} className="bg-transparent border border-gold text-gold font-sans text-xs font-medium tracking-[1.5px] uppercase py-[13px] px-8 cursor-pointer transition-all duration-200 hover:bg-gold hover:text-ink disabled:border-[#2a2a2a] disabled:text-[#2a2a2a] disabled:cursor-not-allowed disabled:hover:bg-transparent" data-id="element-48">
                      Siguiente →
                    </button>
                  </div>
                </div>}

              {/* Step 3 */}
              {step === 3 && <div className="animate-fade-up" data-id="element-49">
                  <div className="text-[11px] tracking-[2px] uppercase text-gold mb-3" data-id="element-50">
                    3 de 6
                  </div>
                  <h3 className="font-serif text-[30px] font-light tracking-tight mb-2 leading-[1.2] text-cream" data-id="element-51">
                    ¿Estás corriendo Meta Ads para tu negocio actualmente?
                  </h3>
                  <p className="text-sm text-muted mb-8 leading-relaxed" data-id="element-52">
                    No hay respuesta correcta o incorrecta — esto nos ayuda a
                    entender tu punto de partida.
                  </p>

                  <div className="flex flex-col gap-2" data-id="element-53">
                    <Option field="ads" value="running" label="Sí — estoy corriendo anuncios ahora mismo" data-id="element-54" />
                    <Option field="ads" value="past" label="He corrido anuncios antes pero no actualmente" data-id="element-55" />
                    <Option field="ads" value="never" label="No, nunca he corrido Meta Ads" data-id="element-56" />
                  </div>

                  <div className="flex justify-between items-center mt-9" data-id="element-57">
                    <button onClick={handleBack} className="bg-transparent border border-[#2a2a2a] text-muted font-sans text-xs font-medium tracking-wide uppercase py-3 px-6 cursor-pointer transition-all duration-200 hover:border-muted hover:text-cream" data-id="element-58">
                      ← Atrás
                    </button>
                    <button onClick={handleNext} disabled={!canProceed()} className="bg-transparent border border-gold text-gold font-sans text-xs font-medium tracking-[1.5px] uppercase py-[13px] px-8 cursor-pointer transition-all duration-200 hover:bg-gold hover:text-ink disabled:border-[#2a2a2a] disabled:text-[#2a2a2a] disabled:cursor-not-allowed disabled:hover:bg-transparent" data-id="element-59">
                      Siguiente →
                    </button>
                  </div>
                </div>}

              {/* Step 4 */}
              {step === 4 && <div className="animate-fade-up" data-id="element-60">
                  <div className="text-[11px] tracking-[2px] uppercase text-gold mb-3" data-id="element-61">
                    4 de 6
                  </div>
                  <h3 className="font-serif text-[30px] font-light tracking-tight mb-2 leading-[1.2] text-cream" data-id="element-62">
                    ¿Cuánto estás dispuesto a invertir mensualmente en ad spend?
                  </h3>
                  <p className="text-sm text-muted mb-8 leading-relaxed" data-id="element-63">
                    Este es tu presupuesto publicitario — separado de nuestro
                    fee de servicio de $1,500/mes.
                  </p>

                  <div className="flex flex-col gap-2" data-id="element-64">
                    <Option field="budget" value="under" label="Menos de $1,000/mes" data-id="element-65" />
                    <Option field="budget" value="1k-2k" label="$1,000 – $2,000/mes" data-id="element-66" />
                    <Option field="budget" value="2k-5k" label="$2,000 – $5,000/mes" data-id="element-67" />
                    <Option field="budget" value="5k+" label="$5,000+/mes" data-id="element-68" />
                  </div>

                  {showBudgetWarning && <div className="mt-4 p-5 px-6 border border-[rgba(184,151,58,0.3)] bg-[rgba(184,151,58,0.05)] animate-fade-up" data-id="element-69">
                      <div className="text-[13px] font-medium text-gold mb-1.5 tracking-wide" data-id="element-70">
                        ⚠ Inversión mínima requerida: $1,000/mes en ad spend
                      </div>
                      <p className="text-[13px] text-muted leading-relaxed" data-id="element-71">
                        Trabajamos con negocios que invierten mínimo $1,000/mes
                        en ads + $1,500/mes en servicio = $2,500/mes total.
                        ¿Estarías dispuesto a llegar a este presupuesto?
                      </p>
                    </div>}

                  <div className="flex justify-between items-center mt-9" data-id="element-72">
                    <button onClick={handleBack} className="bg-transparent border border-[#2a2a2a] text-muted font-sans text-xs font-medium tracking-wide uppercase py-3 px-6 cursor-pointer transition-all duration-200 hover:border-muted hover:text-cream" data-id="element-73">
                      ← Atrás
                    </button>
                    <button onClick={handleNext} disabled={!canProceed()} className="bg-transparent border border-gold text-gold font-sans text-xs font-medium tracking-[1.5px] uppercase py-[13px] px-8 cursor-pointer transition-all duration-200 hover:bg-gold hover:text-ink disabled:border-[#2a2a2a] disabled:text-[#2a2a2a] disabled:cursor-not-allowed disabled:hover:bg-transparent" data-id="element-74">
                      Siguiente →
                    </button>
                  </div>
                </div>}

              {/* Step 5 */}
              {step === 5 && <div className="animate-fade-up" data-id="element-75">
                  <div className="text-[11px] tracking-[2px] uppercase text-gold mb-3" data-id="element-76">
                    5 de 6
                  </div>
                  <h3 className="font-serif text-[30px] font-light tracking-tight mb-2 leading-[1.2] text-cream" data-id="element-77">
                    ¿Usas actualmente un CRM o sistema de seguimiento?
                  </h3>
                  <p className="text-sm text-muted mb-8 leading-relaxed" data-id="element-78">
                    Esto nos indica cuánta infraestructura necesitamos construir
                    para ti desde el inicio.
                  </p>

                  <div className="flex flex-col gap-2" data-id="element-79">
                    <Option field="crm" value="ghl" label="Sí — uso GoHighLevel" data-id="element-80" />
                    <Option field="crm" value="other" label="Sí — uso otro CRM" data-id="element-81" />
                    <Option field="crm" value="manual" label="Hago seguimiento manual (hojas, DMs, etc.)" data-id="element-82" />
                    <Option field="crm" value="none" label="No tengo sistema de seguimiento" data-id="element-83" />
                  </div>

                  <div className="flex justify-between items-center mt-9" data-id="element-84">
                    <button onClick={handleBack} className="bg-transparent border border-[#2a2a2a] text-muted font-sans text-xs font-medium tracking-wide uppercase py-3 px-6 cursor-pointer transition-all duration-200 hover:border-muted hover:text-cream" data-id="element-85">
                      ← Atrás
                    </button>
                    <button onClick={handleNext} disabled={!canProceed()} className="bg-transparent border border-gold text-gold font-sans text-xs font-medium tracking-[1.5px] uppercase py-[13px] px-8 cursor-pointer transition-all duration-200 hover:bg-gold hover:text-ink disabled:border-[#2a2a2a] disabled:text-[#2a2a2a] disabled:cursor-not-allowed disabled:hover:bg-transparent" data-id="element-86">
                      Siguiente →
                    </button>
                  </div>
                </div>}

              {/* Step 6 */}
              {step === 6 && <div className="animate-fade-up" data-id="element-87">
                  <div className="text-[11px] tracking-[2px] uppercase text-gold mb-3" data-id="element-88">
                    6 de 6
                  </div>
                  <h3 className="font-serif text-[30px] font-light tracking-tight mb-2 leading-[1.2] text-cream" data-id="element-89">
                    Casi terminamos. ¿A dónde te enviamos los resultados?
                  </h3>
                  <p className="text-sm text-muted mb-8 leading-relaxed" data-id="element-90">
                    Revisaremos tu solicitud y te contactaremos en menos de 24
                    horas para agendar tu llamada estratégica.
                  </p>

                  <div className="flex flex-col gap-4" data-id="element-91">
                    <div data-id="element-92">
                      <label className="block text-[11px] tracking-[1.5px] uppercase text-muted mb-2" data-id="element-93">
                        Nombre Completo *
                      </label>
                      <input type="text" value={formData.name} onChange={e => handleSelect('name', e.target.value)} placeholder="Tu nombre completo" className="w-full p-3.5 px-4.5 bg-[#0a0a0a] border border-[#1e1e1e] text-cream font-sans text-[15px] font-light outline-none transition-colors duration-200 focus:border-gold placeholder:text-[#2a2a2a]" data-id="element-94" />
                    </div>
                    <div data-id="element-95">
                      <label className="block text-[11px] tracking-[1.5px] uppercase text-muted mb-2" data-id="element-96">
                        Correo Electrónico *
                      </label>
                      <input type="email" value={formData.email} onChange={e => handleSelect('email', e.target.value)} placeholder="tu@correo.com" className="w-full p-3.5 px-4.5 bg-[#0a0a0a] border border-[#1e1e1e] text-cream font-sans text-[15px] font-light outline-none transition-colors duration-200 focus:border-gold placeholder:text-[#2a2a2a]" data-id="element-97" />
                    </div>
                    <div data-id="element-98">
                      <label className="block text-[11px] tracking-[1.5px] uppercase text-muted mb-2" data-id="element-99">
                        Número de Teléfono *
                      </label>
                      <input type="tel" value={formData.phone} onChange={e => handleSelect('phone', e.target.value)} placeholder="+1 (555) 000-0000" className="w-full p-3.5 px-4.5 bg-[#0a0a0a] border border-[#1e1e1e] text-cream font-sans text-[15px] font-light outline-none transition-colors duration-200 focus:border-gold placeholder:text-[#2a2a2a]" data-id="element-100" />
                    </div>
                    <div data-id="element-101">
                      <label className="block text-[11px] tracking-[1.5px] uppercase text-muted mb-2" data-id="element-102">
                        Nombre del Negocio
                      </label>
                      <input type="text" value={formData.businessName} onChange={e => handleSelect('businessName', e.target.value)} placeholder="Tu agencia de reparación de crédito" className="w-full p-3.5 px-4.5 bg-[#0a0a0a] border border-[#1e1e1e] text-cream font-sans text-[15px] font-light outline-none transition-colors duration-200 focus:border-gold placeholder:text-[#2a2a2a]" data-id="element-103" />
                    </div>
                  </div>

                  <button onClick={handleSubmit} className="w-full mt-8 bg-gold border border-gold text-ink font-sans text-[13px] font-semibold tracking-[1.5px] uppercase p-[18px] cursor-pointer transition-all duration-250 hover:bg-gold-bright hover:shadow-[0_12px_40px_rgba(184,151,58,0.2)]" data-id="element-104">
                    Enviar mi Solicitud →
                  </button>

                  <p className="text-center mt-4 text-[11px] text-[#2a2a2a] tracking-wide" data-id="element-105">
                    Sin spam. Sin compromisos. Revisamos y te contactamos en
                    menos de 24 horas.
                  </p>

                  <div className="flex mt-5" data-id="element-106">
                    <button onClick={handleBack} className="bg-transparent border border-[#2a2a2a] text-muted font-sans text-xs font-medium tracking-wide uppercase py-3 px-6 cursor-pointer transition-all duration-200 hover:border-muted hover:text-cream" data-id="element-107">
                      ← Atrás
                    </button>
                  </div>
                </div>}
            </> /* Success State */ : <div className="text-center py-10 animate-fade-up" data-id="element-108">
              <div className="w-[72px] h-[72px] rounded-full border border-gold-line flex items-center justify-center mx-auto mb-8 text-[28px] bg-gold-pale text-gold-bright" data-id="element-109">
                ✓
              </div>
              <h3 className="font-serif text-[36px] font-light mb-3.5 text-cream" data-id="element-110">
                ¡Solicitud Recibida!
              </h3>
              <p className="text-[15px] text-muted leading-relaxed" data-id="element-111">
                Hemos recibido tu información y la revisaremos en las próximas
                24 horas.
                <br data-id="element-112" />
                Si eres un buen candidato, te contactaremos para agendar tu
                llamada estratégica gratuita.
              </p>
            </div>}
        </div>
      </div>
    </section>;
}